import React from 'react';
import { FiUsers, FiPieChart } from 'react-icons/fi';

const StatsOverview = ({ statistics }) => {
  if (!statistics) return null;

  const topClusters = statistics.clusterDistribution?.slice(0, 5) || [];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Overview</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Total Students */}
        <div className="flex items-start space-x-4">
          <div className="p-3 bg-primary-100 rounded-lg">
            <FiUsers className="h-6 w-6 text-primary-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Total Students</p>
            <p className="text-2xl font-bold text-gray-900">{statistics.totalStudents}</p>
          </div>
        </div>

        {/* Top Career Clusters */}
        <div className="flex items-start space-x-4">
          <div className="p-3 bg-green-100 rounded-lg">
            <FiPieChart className="h-6 w-6 text-green-600" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-gray-600 mb-2">Top Career Clusters</p>
            <div className="space-y-1">
              {topClusters.map((item, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-gray-700 truncate mr-2">{item.cluster}</span>
                  <span className="text-gray-900 font-medium">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;
